import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { formatSSN } from 'utils/formatters/ssn'
import { EN_DASH_DEFAULT_VALUE } from 'utils/constants/defaultValues'

import styles from './SSNPlaceholder.module.scss'

export const SSNPlaceholder = ({
  className,
  dataTestId,
  isHidden = true,
  placeholder = '',
  spacing = '\u00a0-\u00a0',
  ssn,
}) => {
  let content = EN_DASH_DEFAULT_VALUE

  if (placeholder) {
    content = (
      <Fragment>
        {isHidden && (
          <Fragment>
            <span className={styles.dots}>&bull;&bull;&bull;</span>
            <span>{spacing}</span>
            <span className={styles.dots}>&bull;&bull;</span>
            <span>{spacing}</span>
            <span data-test-id="ssn-placeholder">{placeholder.slice(-4)}</span>
          </Fragment>
        )}

        {!isHidden && formatSSN(ssn, EN_DASH_DEFAULT_VALUE)}
      </Fragment>
    )
  }

  return (
    <div className={classNames(styles.container, className)} data-test-id={dataTestId}>
      <div className={styles.content}>{content}</div>
    </div>
  )
}

SSNPlaceholder.propTypes = {
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  isHidden: PropTypes.bool,
  placeholder: PropTypes.string,
  spacing: PropTypes.node,
  ssn: PropTypes.string,
}
